module.exports = __webpack_public_path__ + "img/warning.14049d7a.svg";